import { IncUtmActionTypes, LinksUtm } from "../consts";
import { incUtm } from "../api";
import localStorageAvailable from "../utils/minimal/localStorageAvailable";

export const AnalyticsService = {
    async incUtm(utm, accountId, eventId) {
        try {
            const utmName = utm ?? LinksUtm.PRIMARY
            let isFirstVisit = true

            /* Inc times this page was viewed */
            await incUtm({ accountId, eventId, utmData: { utm: utmName, action: IncUtmActionTypes.VIEWS } })

            if (localStorageAvailable()) {
                const localStorageKey = `${utm}_${eventId}`
                const isAlreadyVisited = localStorage.getItem(localStorageKey)
                isFirstVisit = !isAlreadyVisited
                localStorage.setItem(localStorageKey, true)
            }

            /* Inc unique view */
            if (isFirstVisit) {
                await incUtm({ accountId, eventId, utmData: { utm: utmName, action: IncUtmActionTypes.UNIQUE_VIEWS } })
            }
        } catch (e) {
            console.log(e);
        }
    }
}